import styled from 'styled-components';

export const Button = styled.div`
position: fixed;
height: 20px;
font-size: 3rem;
bottom: 50px;
right: 25px;
color: black;
cursor: pointer;
z-index: 1;
`
